module.exports = __webpack_public_path__ + "img/public/SiteIcons/noPayoutMethod.svg?7ba607bc";